import React, { createContext, useState } from "react";

export const UserContext = createContext();
export const UserContextProvider = (props) => {
  const [data, setData] = useState([]);
  const [payment, setPayment] = useState([]);
  const [notification, setNotification] = useState([]);
  const [sum, setSum] = useState({
    _id: {},
    sum_cost: 0,
    sum_net: 0,
    sum_request: 0,
    sum_size: 0,
    sum_vat: 0,
    balance: 0,
    fetch: false,
  });
  const [state, setstate] = useState({
    _id: "",
    email: "",
    first_name: "",
    last_name: "",
    organization: "",
    address: "",
    tambon: "",
    amphoe: "",
    province: "",
    zipcode: "",
    country: "",
    phone: "",
    billing_info: {
      first_name: "",
      last_name: "",
      organization: "",
      address: "",
      tambon: "",
      amphoe: "",
      province: "",
      zipcode: "",
      country: "",
      phone: "",
      tax: "",
    },
    role: "",
    created_at: "",
    profile_picture: "",
    google: null,
    facebook: null,
    mea: null,
    contract: {
      start_date: "",
      end_date: "",
    },
  });

  return (
    <UserContext.Provider
      value={{
        data: data,
        setData: setData,
        state: state,
        setstate: setstate,
        sum: sum,
        setSum: setSum,
        payment: payment,
        setPayment: setPayment,
        notification: notification,
        setNotification: setNotification,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};
